import { render, staticRenderFns } from "./contactCenHzzx.vue?vue&type=template&id=5d205b7c&scoped=true"
import script from "./contactCenHzzx.vue?vue&type=script&lang=js"
export * from "./contactCenHzzx.vue?vue&type=script&lang=js"
import style1 from "./contactCenHzzx.vue?vue&type=style&index=1&id=5d205b7c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d205b7c",
  null
  
)

export default component.exports